module.exports = __webpack_public_path__ + "static/media/ACM-BVP-logo.6425d80f.png";